import { render, staticRenderFns } from "./TelegramChatAddOwnersModal.vue?vue&type=template&id=3f617773&lang=pug&"
import script from "./TelegramChatAddOwnersModal.vue?vue&type=script&lang=js&"
export * from "./TelegramChatAddOwnersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports